export default __webpack_public_path__ + "static/media/kd1.de5fdd0b.JPG";